import {
    Component,
    EventEmitter,
    Input,
    Output,
    OnInit,
} from "@angular/core";

import { IdName } from "../domain/idname";

@Component({
    selector: "list-table",
    templateUrl: "./list-table.component.html",
})
export class ListTableComponent implements OnInit {

    constructor() {}

    @Input() inputListNodes: IdName[];
    @Input() listColumns: any[];
    @Input() selectionMode: string = "single";

    @Input() loadingListNodes = true;

    searchValue: string = null;
    listNodesForTable: IdName[];

    ngOnInit() {}

    clearSelection() {
        this.selected = null;
    }

    @Input() range: boolean;
    @Input() removeLoader: boolean;

    @Output() voted = new EventEmitter<boolean>();


    @Input() filter: IdName[];

    @Input() selected: IdName[];
    @Output() unselectedNode = new EventEmitter<IdName>();

    @Output() selectedChange = new EventEmitter<IdName[]>();
    @Output() onSearchEnter = new EventEmitter<IdName[]>();

    didVote = false;

    totalAccountsNumber: number;
    fullAccountsData: IdName[];

    selectNode() {
        this.selectedChange.emit(this.selected);
    }

    unselectNode() {
        this.selectedChange.emit(this.selected);
    }
}
